import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const AUDIT_ACTIONS = {
  EULA_ACCEPT:        'eula_accept',
  LOGIN:              'auth_login',
  PDF_SETUP:          'pdf_export_setup',
  PDF_WORKORDER:      'pdf_export_workorder',
  PDF_BILLING:        'pdf_export_billing',
  PDF_RACE_ENGINEER:  'pdf_export_race_engineer',
  AI_COACHING:        'ai_coaching_request',
  SETUP_CREATE:       'setup_create',
  SETUP_EDIT:         'setup_edit',
  SETUP_DELETE:       'setup_delete',
  TEAM_INVITE:        'team_invite',
};

export async function logAudit(userId, teamId, action, details = {}) {
  if (!userId) return;
  try {
    await addDoc(collection(db, 'auditLog'), {
      userId,
      teamId: teamId || null,
      action,
      details,
      timestamp: serverTimestamp(),
      ua: navigator.userAgent.substring(0, 200),
    });
  } catch (_) {
    // audit log failure is always silent — never block the user
  }
}
